import Image from 'next/image';
import styled from 'styled-components';

import { Feedback } from '@shared/constants/feedback';

type FeedbackUserProps = Omit<
  Feedback,
  'descriptionMain' | 'descriptionSlave'
> & {
  fontSize?: number;
  lineHeight?: number;
};

function FeedbackUser({
  userName,
  fontSize,
  lineHeight,
  userCompany,
  companyImage,
}: FeedbackUserProps) {
  return (
    <Wrapper>
      <UserInfoWrapper>
        <UserName $fontSize={fontSize} $lineHeight={lineHeight}>
          {userName}
        </UserName>
        <UserCompany>{userCompany}</UserCompany>
      </UserInfoWrapper>

      <AvatarWrapper>
        <StyledImage
          fill
          alt={userName}
          src={companyImage}
          loading="lazy"
          sizes="(max-width: 1440px) 100px, (max-width: 935px) 100px, (max-width: 768px) 100px, (max-width: 375px) 100px"
        />
      </AvatarWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 45px;
  width: 100%;
`;

const AvatarWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  height: 100%;

  max-width: 100px;
  width: 40%;
`;

const UserInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 60%;
`;

const UserName = styled.span<{ $fontSize?: number; $lineHeight?: number }>`
  font-weight: 600;
  font-size: ${({ $fontSize }) => $fontSize || 20}px;
  line-height: ${({ $lineHeight }) => $lineHeight || 26}px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const UserCompany = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  font-style: italic;
  color: ${({ theme }) => theme.colors.textSecondary};
`;

const StyledImage = styled(Image)`
  object-fit: contain;
`;

export default FeedbackUser;
